import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-unfold",
  "use": "icon-s-unfold-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-s-unfold\">\n<path d=\"M2.75 4.125H19.25V6.875H2.75V4.125ZM2.75 9.625H13.75V12.375H2.75V9.625ZM2.75 15.125H19.25V17.875H2.75V15.125ZM15.125 8.25968L19.25 11L15.125 13.75V8.25968Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/s-unfold.svg
// module id = 6La4
// module chunks = 258